import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../../features/auth/services/auth.service';

/**
 * Bank administration (banks, branches, regions, invited admins): superusers
 * everywhere, global users within their own bank.
 */
export const bankAdminGuard: CanActivateFn = async (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    await authService.profileReady();

    if (authService.isSuperUser || authService.isGlobal) {
        return true;
    }

    if (state.url !== '/no-access') {
        router.navigate(['/no-access']);
    }
    return false;
};
